export default { SaveData: 'SaveData' };
